export default function Footer() {
  return (
    <footer className="border-t border-line bg-paper px-6 py-8 md:px-12">
      <div className="mx-auto max-w-content">
        <p className="text-xs text-ink-faint">
          &copy; {new Date().getFullYear()} Ellen Boakye &middot; Rehabilitation Specialist &amp; Accessibility Developer
        </p>
      </div>
    </footer>
  );
}
